module.exports = __webpack_public_path__ + "static/media/platform1.77968697.png";